import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
    const { user, adminToken, loading, isAdmin } = useAuth();
    const location = useLocation();

    // 1. If we are still checking the session, show a simple loading screen
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                height: '100vh',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: 'Montserrat, sans-serif',
                color: '#630000'
            }}>
                <h3>Verifying Admin Access...</h3>
            </div>
        );
    }

    // 2. If loading is done and we don't have a valid admin, redirect to login
    if (!user || !isAdmin || !adminToken) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    // 3. If all checks pass, show the dashboard
    return children;
};

export default AdminRoute;
